"use client";
import { useState } from "react";
import dynamic from "next/dynamic";

import { getGa4SearchEventParams } from "src/helpers/google-tag-manager/event-helpers/search";
import { formGTMEventGA4 } from "src/helpers/google-tag-manager/common";
import { slugify } from "@/src/utils/string";

import Input from "components/common/input";
import Button from "components/common/button";

import styles from "./styles.module.css";

const SuggestionBox = dynamic(() => import("components/common/suggestion-box"), { ssr: false });

const EstateOfficePanel = () => {
  const [freeText, setFreeText] = useState("");
  const [message, setMessage] = useState(false);

  const handleChangeText = (e) => {
    setMessage(false);
    setFreeText(e.target.value);
  };

  const handleAgentClick = (item) => {
    const criteriaFreeText = {
      freetext: {
        value: slugify(item?.name),
      },
    };

    const ga4SearchEventParams = getGa4SearchEventParams({
      btnCategory: "search",
      criteriaState: criteriaFreeText,
      activeTab: "emlak-ofisleri",
      structuredValue: slugify(item?.name),
    });

    formGTMEventGA4({ eventName: "search", eventParameters: ga4SearchEventParams });

    window.location.href = item?.url;
  };

  const handleSearchClick = () => {
    setFreeText("");
    setMessage(true);
  };

  const handleKeyPress = (e) => {
    if (e.code === "Enter") {
      handleSearchClick();
    }
  };

  return (
    <div className={styles.tabpanel}>
      <div className={styles.field}>
        <span className={styles.title}>Emlak Ofisi</span>
        <div className={styles.input}>
          <Input
            onChange={handleChangeText}
            value={freeText}
            placeholder="Emlak ofisinin adını yazınız"
            onKeyPress={handleKeyPress}
          />
          {message && (
            <div className={styles.dangerMessage}>
              Lütfen aradığınız emlakçıyı öneri listesinden seçerek ilerleyiniz.
            </div>
          )}
        </div>
        <SuggestionBox
          agent
          freeText={freeText}
          handlePOIClick={handleAgentClick}
          suggestionClass={styles.suggestionClass}
        />
      </div>
      <div className={`${styles.field} h-full flex items-end`}>
        <div className={styles.searchbutton}>
          <Button onClick={handleSearchClick} size="Auto">
            Ara
          </Button>
        </div>
      </div>
    </div>
  );
};

EstateOfficePanel.propTypes = {};

export default EstateOfficePanel;
